import React from 'react';
import ReactDOM from 'react-dom/client';
import Login from './Login';
import Varify from './Varify';
import Dashboard from './Dashboard';
import ChangePwd from './ChangePwd';
import Logout from './Logout';

import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route,} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <Routes>
      <Route exact path="/" element={<Login />}></Route>
      <Route exact path="/varify" element={<Varify />}></Route>
      <Route exact path="/dashboard" element={<Dashboard />}></Route>
      <Route exact path="/change-password" element={<ChangePwd />}></Route>
      <Route exact path="/logout" element={<Logout />}></Route>
      <Route path="*" element={<Login />}></Route>
    </Routes>
  </BrowserRouter>
// </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
